import React from 'react';
import { TypedMemo } from '../../../../../common/types';
import { useCoverRedo } from './useCoverRedo';
import { CoverRedoPanel } from './CoverRedoPanel';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the cover redo; each part uses its own slice of it */
import styles from './CoverRedo.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The cover redo banner over the Posts board of a release (design kit-redo-cover a). */
const ReleasePostsCoverRedoComponent: React.FC<{ accountId: number; catalogItemUuid: string }> = ({
  accountId,
  catalogItemUuid,
}) => {
  const redo = useCoverRedo({ accountId, catalogItemUuid });
  if (redo.banner === 'hidden' && !redo.showsQuietLine) {
    return null;
  }
  return (
    <div className={styles.postsSlot}>
      <CoverRedoPanel accountId={accountId} catalogItemUuid={catalogItemUuid} redo={redo} />
    </div>
  );
};

export const ReleasePostsCoverRedo = TypedMemo(ReleasePostsCoverRedoComponent);
